module.exports = __webpack_public_path__ + "static/img/teacher_2.1020ba47.png";